import React from "react";

import YourAir from "./pages/YourAir/YourAir";

function App() {
  return (
    <div className="App">
      <YourAir />
    </div>
  );
}

export default App;
